export class AccredibleToastConfig {
  duration = 4000;
  errorDuration = 8000;
}
